import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressPosts = () => {
    const setPosts = useWordPressStore((state) => state.setPosts);

    return useMutation(WordpressApi.getPosts, {
        onSuccess: (data) => {
            setPosts(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};